module.exports = __webpack_public_path__ + "static/media/odin.be2cbc0b.JPG";